export const GET_DASHBOARD_INFO = 'GET_DASHBOARD_INFO';
export const GET_DASHBOARD_INFO_SUCCESS = 'GET_DASHBOARD_INFO_SUCCESS';
export const GET_DASHBOARD_INFO_FAILED = 'GET_DASHBOARD_INFO_FAILED';
